import ImageClass from "@lss/common/src/shell/Image";
import { mc } from "@lss/common/game/characters/MC";
import { images } from "@lss/common/game/story/images";
import Question from "../../src/shell/Questions";
import { empty } from "../characters/empty";
import { ann } from "../characters/Ann";
import { jump } from "../../src/shell/jump";
import { RoomAfterEventsBTNS, RoomAfterRecapBTNS } from "./V3";
import { alex } from "../characters/Alex";
import { Insta } from "../../src/components/insta/InstaClass";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { parseRequire } from "../../src/utils/parseImageUrl";
import { chris } from "../characters/Chris";
import { joe } from "../characters/Joe";
import Game from "../../src/shell/Game";
import { store } from "../../src/store/store";
import { setQuestionAnswer } from "../../src/store/slices/gameObjectSlice";
import { getInstaImage } from "../helpers/helpers";



export const AnnAfterTODNotLove = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`I should tell Ann she forgot her book at my place.`);
    if (Question.globalAnswers.todAnnHateLivingRoomConv === "haveFun") {
        mc.think(`She didn't take it kindly when I said I just wanna have fun when I was left alone with her.`);
        mc.think(`But it is what it is.`);
    } else {

        mc.think(`I did apologize yesterday so she might forgive me.`);
    }
    if (!mc.properties.knowsAlexAndAnnFriends && getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}8`)?.mcSeen) {
        await mc.set((properties) => {
            properties.knowsAlexAndAnnFriends = true;
        });
        mc.think(`And now I know she is a friend of Alex.`);
        mc.think(`Maybe I can ask Ann about her...`);
    }
    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingVanessa);
    empty.think(`Calling Ann...`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    ann.talk(`Hello?`);
    mc.talk(`Hey Ann, I just wanted to let you know that you forgot your book at my place.`);
    ann.talk(`So that's where it was!!!`);
    ann.talk(`My mind was in a different place so I totally forgot about that.`);

    ann.talk(`Can you please give it back to me?`);
    mc.talk(`When?`);
    ann.talk(`Right now would be awesome.`);
    ann.talk(`I'm currently at the library studying...`);
    mc.think(`I am the reason she's in a bad mood.`);
    mc.think(`The least I can do is take the book to her.`);
    mc.talk(`Sure, I'll bring it.`);
    ann.talk(`Thank you! I'll be here for a while.`);
    return jump(AnnAfterTODNotLove2, "AnnAfterTODNotLove2");

};
export const AnnAfterTODNotLove2 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`Time to go to the library...`);
    ImageClass.setImage(images.v3.AnnLibrary1, { transition: true });
    mc.think(`There she is.`);
    mc.think(`She doesn't seem to be doing much studying.`);
    ImageClass.setImage(images.v3.AnnLibrary2);
    mc.talk(`Hey Ann.`);
    ImageClass.setImage(images.v3.AnnLibrary3);
    ann.talk(`Oh, hey.`);

    mc.talk(`Here is your book.`);
    ImageClass.setImage(images.v3.AnnLibrary4);

    await mc.setQuestion(new Question({ text: `Thanks!`, key: `v3mcAnnLibraryAskAboutPhone` })
        .option({ title: `Who is that on the phone?`, key: true })
        .option({ title: `You're welcome!`, key: false }));


    if (Question.globalAnswers.v3mcAnnLibraryAskAboutPhone) {
        mc.talk(`Who is that on the phone?`);
        ann.talk(`No one.`);
        ann.talk(`I was just checking the news.`);
    } else {
        mc.talk(`You're welcome!`);
    }

    ann.talk(`Hey, ${mc.name}.`);
    ann.talk(`Please wait here for a few seconds.`);
    ann.talk(`I really need to use the bathroom, can you watch my laptop?`);
    mc.talk(`Sure.`);

    ImageClass.setImage(images.v3.AnnLibrary7);
    mc.think(`Even at the bar she went to the bathroom; she has a really small bladder.`);

    await mc.setQuestion(new Question({ text: `She did leave her phone here...`, options: { think: true }, key: `v3mcAnnLibraryCheckedAnnPhone` })
        .option({ title: `Check it`, key: true })
        .option({ title: `Don't touch it`, key: false }));

    if (Question.globalAnswers.v3mcAnnLibraryCheckedAnnPhone) {
        mc.think(`I'm too curious not to check it.`);
        if (Question.globalAnswers.v3mcAnnLibraryAskAboutPhone) {
            mc.think(`Let's see if she was really checking the news.`);
        }
        let name = "Mom";
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            name = chris.name;
        } else if (Question.globalAnswers.v25JoeTODAgree) {
            name = joe.name;
        }
        await Phone.showMessagesUI({ name, wallpaper: ann.properties.v1AnnWallpaper }, async () => {
            let readit = Game.seenScenarios.includes(`AnnAfterTODNotLove2`);
            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                Phone.setMessage({ text: `Hey beautiful!`, character: chris.character, options: { wait: false } });
                Phone.setMessage({ text: `What do I need to do to get you to meet me?`, character: chris.character, options: { wait: readit } });
                Phone.setMessage({ character: mc.character, text: `I never thought I'd go out with a guy like you.`, options: { wait: readit } });
                Phone.setMessage({ character: mc.character, text: `But I might...`, options: { wait: readit } });
                Phone.setMessage({ character: mc.character, text: `Talk to you soon.`, options: { wait: readit } });
                Phone.talk({ character: mc.character, text: `I knew it!`, options: { think: true } });
                Phone.talk({ character: mc.character, text: `She was texting Chris.`, options: { think: true } });
            } else if (Question.globalAnswers.v25JoeTODAgree) {
                Phone.setMessage({ character: mc.character, text: `Hey Joe, I just wanted to say that I had a really fun time yesterday....`, options: { wait: false } });

                Phone.setMessage({ character: mc.character, text: `You are a great kisser....`, options: { wait: readit } });

                Phone.setMessage({ character: mc.character, text: `Well....`, options: { wait: readit } });

                Phone.setMessage({ character: mc.character, text: `Yeah... That's all I wanted to say...`, options: { wait: readit } });
                Phone.setMessage({ character: joe.character, text: `I hope we can do it again sometime!`, options: { wait: readit } });
                Phone.talk({ character: mc.character, text: `I knew she was texting someone, but... Joey?`, options: { think: true } });
                Phone.talk({ character: mc.character, text: `It seems like Ann was the first who sent him a message.`, options: { think: true } });
                Phone.talk({ character: mc.character, text: `And what did he mean by do it again?`, options: { think: true } });
                Phone.talk({ character: mc.character, text: `Did he mean to play truth or dare or to kiss Ann?`, options: { think: true } });
                Phone.talk({ character: mc.character, text: `Weird, I just met with him and he didn't mention any of that...`, options: { think: true } });

            } else {
                Phone.setMessage({ character: mc.character, text: `Hey mom, what's for dinner?`, options: { wait: false } });
                Phone.talk({ character: mc.character, text: "I shouldn't expected more.", options: { think: true } });

            }

            Phone.closeMessagesUI();
        });
    } else {
        mc.think(`I respect her privacy.`);
        mc.think(`I'll just wait for her to come back.`);
    }

    return jump(AnnAfterTODNotLove3, "AnnAfterTODNotLove3");
};
export const AnnAfterTODNotLove3 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.AnnLibrary7);
    mc.think(`She is coming back.`);
    ImageClass.setImage(images.v3.AnnLibrary4);
    ann.talk(`Thanks for waiting.`);
    mc.talk(`No problem.`);
    ann.talk(`So, I should get back to studying...`);
    mc.talk(`Alright, I'll be going now.`);
    ann.talk(`Bye ${mc.name}, and thanks again!`);
    ImageClass.setImage(images.v3.AnnLibrary4);
    if (getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}8`)?.mcSeen && Insta.instaProfiles?.[alex.name]?.images.filter(image => image.mcLiked).length > 5) {
        await mc.setQuestion(new Question({ text: `I can ask her about Alex or just leave.`, options: { think: true }, key: `v3mcAnnLibraryAskedAboutAlex` })
            .option({ title: `Ask about Alex`, key: true })
            .option({ title: `Just leave`, key: false }));


        if (Question.globalAnswers.v3mcAnnLibraryAskedAboutAlex) {
            mc.talk(`Before I leave I wanted to ask you something.`);
            ann.talk(`Sure, what is it?`);

            mc.talk(`I saw your picture on Insta.`);
            ann.talk(`My picture?`);
            mc.talk(`Yes, in Alex's profile.`);
            ann.talk(`Do you know her?`);
            mc.talk(`Not really, I just follow her.`);
            ImageClass.setImage(images.v3.AnnLibrary5);
            ann.talk(`It all makes sense now.`);
            mc.talk(`What makes sense?`);
            ann.talk(`...`);
            mc.talk(`Ann?`);
            await ann.setQuestion(new Question({ text: `You saw Alex and you are interested in her, that's why you turned me down.`, key: `v3mcAnnLibraryInterestedInAlex` })
                .option({ title: `Say that's true`, key: true })
                .option({ title: `Say that's not true`, key: false }));


            if (Question.globalAnswers.v3mcAnnLibraryInterestedInAlex) {
                mc.talk(`I do find her attractive.`);
                ann.talk(`Well, good for you.\nSo does everyone else.`);
                ann.talk(`Good luck with that.`);
                ann.talk(`Bye ${mc.name}.`);
            } else {
                mc.talk(`That's not true.`);
                ann.talk(`Fine, whatever.`);
                ann.talk(`I'm not stupid you know, why would you ask about her anyway?`);
                mc.talk(`I was just asking.`);
                ann.talk(`I should really get back to study.`);
                ann.talk(`Bye ${mc.name}.`);
            }

        } else {
            mc.talk(`Good luck with your studying.`);
            ann.talk(`Thanks you!`);
            ann.talk(`And thanks again for the book.`);
        }
    }


    if (mc.properties.joeStatus !== "enemy") {

        return jump(RoomAfterEventsBTNS, "RoomAfterEventsBTNS");
    }
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};


